import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API_BASE_URL from "../config/api";
import axios from "axios";

export default function SignUpPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    // username: ''
  });
  const [error, setError] = useState("");

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) {
      setError("Passwords don't match");
      return;
    }
    try {
      await axios.post(API_BASE_URL + "auth/register", {
        email: form.email,
        password: form.password,
        // username: form.username
      });
      navigate("/signin");
    } catch (err) {
      setError(err.response?.data?.msg || "Registration failed");
    }
  };

  return (
    <div className="container py-5" style={{ maxWidth: "400px" }}>
      <h2 className="mb-4 text-center">Sign Up</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit} noValidate>
        {/* <div className="mb-3">
          <label htmlFor="signup-username" className="form-label">Username</label>
          <input
            type="text"
            id="signup-username"
            name="username"
            className="form-control"
            value={form.username}
            onChange={handleChange}
            required
          />
        </div> */}
        <div className="mb-3">
          <label htmlFor="signup-email" className="form-label">
            Email
          </label>
          <input
            type="email"
            id="signup-email"
            name="email"
            className="form-control"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="signup-password" className="form-label">
            Password
          </label>
          <input
            type="password"
            id="signup-password"
            name="password"
            className="form-control"
            value={form.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="signup-confirm" className="form-label">
            Confirm Password
          </label>
          <input
            type="password"
            id="signup-confirm"
            name="confirmPassword"
            className="form-control"
            value={form.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>
        <button className="btn btn-success w-100 mb-3">Create Account</button>
      </form>
      <p className="text-center">
        Already registered? <Link to="/signin">Sign In</Link>
      </p>
    </div>
  );
}
